export default (name) => {
  return String(name).replace(/###/g, '.').replace(/^_/, '');
};
